import React, { useState, useEffect } from 'react';
import EventListItem from './EventListItem';
import { resolveEventLocation } from '../lib/location';

/**
 * Event Filter Component
 * Filters events by: all, ticketed (paid), or exclusive discount
 * Also filters out past events automatically
 */
export default function EventFilter({ events, businesses, locations, analytics }) {
  const [activeFilter, setActiveFilter] = useState('all');
  const [filteredEvents, setFilteredEvents] = useState([]);
  const [counts, setCounts] = useState({ all: 0, ticketed: 0, exclusive: 0 });

  useEffect(() => {
    // Get today's date at midnight for comparison
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Filter to only upcoming events and categorize
    const upcomingEvents = events.filter(event => {
      const eventDate = new Date(event.eventDate);
      eventDate.setHours(0, 0, 0, 0);
      return eventDate >= today;
    });

    // Count events by category
    const allCount = upcomingEvents.length;
    const ticketedCount = upcomingEvents.filter(e => e.isTicketed).length;
    const exclusiveCount = upcomingEvents.filter(e => e.hasExclusive).length;

    setCounts({ all: allCount, ticketed: ticketedCount, exclusive: exclusiveCount });

    // Apply current filter
    let filtered = upcomingEvents;
    if (activeFilter === 'ticketed') {
      filtered = upcomingEvents.filter(e => e.isTicketed);
    } else if (activeFilter === 'exclusive') {
      filtered = upcomingEvents.filter(e => e.hasExclusive);
    }

    setFilteredEvents(filtered);
  }, [events, activeFilter]);

  const handleFilterChange = (filterId) => {
    setActiveFilter(filterId);
    if (analytics) {
      analytics.trackInteraction('filter_events', { filter: filterId });
    }
  };

  const tabs = [
    { id: 'all', label: 'All Events', count: counts.all },
    { id: 'ticketed', label: 'Paid', count: counts.ticketed },
    { id: 'exclusive', label: 'Exclusive Discount', count: counts.exclusive },
  ];

  return (
    <div>
      {/* Filter tabs — Bluesky-style pills ("For You") */}
      <div className="feed-tabs mb-6">
        {tabs.map(tab => (
          <button
            key={tab.id}
            onClick={() => handleFilterChange(tab.id)}
            className={`tab-pill ${activeFilter === tab.id ? 'tab-pill--active' : 'tab-pill--inactive'}`}
            data-filter={tab.id}
          >
            {tab.label}
            <span className={activeFilter === tab.id ? 'text-pink-100' : 'text-gray-400'}>({tab.count})</span>
          </button>
        ))}
      </div>

      {/* No events message */}
      {filteredEvents.length === 0 && (
        <div className="post text-center py-12">
          <p className="text-gray-600">No events found for this filter.</p>
        </div>
      )}

      {/* Event feed — post cards */}
      {filteredEvents.length > 0 && (
        <div className="space-y-6">
          {filteredEvents.map(event => {
            const business = businesses.find(b => b.id === event.businessId);
            const location = resolveEventLocation(event, business, locations);
            return (
              <EventListItem
                key={event.id}
                event={event}
                business={business}
                location={location}
                analytics={analytics}
              />
            );
          })}
        </div>
      )}
    </div>
  );
}

